export enum ClipboardType {
    IMAGE_PNG = 'image/png',
    IMAGE_JPEG = 'image/jpeg',
    IMAGE_GIF = 'image/gif',
    IMAGE_BMP = 'image/bmp',
    IMAGE_SVG_XML = 'image/svg+xml',
    HTML = 'text/html',
    TEXT = 'text/plain'
}
